var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRebaseLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 311.49 61.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:black;}.cls-4{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -27.7,
    y1: 1.81,
    x2: 87.17,
    y2: 77.27,
    gradientTransform: "translate(0 0.03)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00cd82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -11.66,
    y1: -22.61,
    x2: 103.22,
    y2: 52.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 300.48,
    y1: 53.37,
    x2: 311.48,
    y2: 53.37,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.9,45.24H16.11V60.37H0V3.42H26A32.42,32.42,0,0,1,39.45,6a19.79,19.79,0,0,1,8.79,7.32,20.07,20.07,0,0,1,3.09,11.18,19.87,19.87,0,0,1-2.88,10.78,19.56,19.56,0,0,1-8.26,7.2l12.28,17.9H35.23Zm7.64-26.93c-1.68-1.46-4.18-2.2-7.48-2.2H16.11V32.79h9q5,0,7.48-2.16a7.62,7.62,0,0,0,2.52-6.14A7.76,7.76,0,0,0,32.54,18.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.29,42.22H72.24A9,9,0,0,0,76,47.47a12.66,12.66,0,0,0,7,1.83,15.33,15.33,0,0,0,5.49-.89,16.32,16.32,0,0,0,4.68-2.93l8.14,8.46q-6.44,7.16-18.8,7.16A30,30,0,0,1,69,58.17,21.6,21.6,0,0,1,56.7,38.24a22.18,22.18,0,0,1,3.13-11.68,21.9,21.9,0,0,1,8.67-8.09,27.77,27.77,0,0,1,24.4-.21,20.78,20.78,0,0,1,8.5,7.89,23.18,23.18,0,0,1,3.14,12.25C104.54,38.51,104.46,39.78,104.29,42.22ZM75.05,28.56a9.15,9.15,0,0,0-3,5.53H90.06A9.21,9.21,0,0,0,87,28.56a9.77,9.77,0,0,0-12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.41,20.29a19.48,19.48,0,0,1,7.52,7.65,22.67,22.67,0,0,1,2.73,11.19,22.43,22.43,0,0,1-2.73,11.14,19.68,19.68,0,0,1-7.52,7.65,21.26,21.26,0,0,1-10.74,2.77A19.74,19.74,0,0,1,126.38,58a18.52,18.52,0,0,1-7.12-7.6v10h-3.9V0h4.07V27.58a18.34,18.34,0,0,1,7.08-7.37,19.93,19.93,0,0,1,10.17-2.64A21.43,21.43,0,0,1,147.41,20.29Zm-2.2,34.46a16.24,16.24,0,0,0,6.14-6.35,18.92,18.92,0,0,0,2.24-9.27,19,19,0,0,0-2.24-9.28,16.28,16.28,0,0,0-6.14-6.34,17.09,17.09,0,0,0-8.79-2.28,16.86,16.86,0,0,0-8.74,2.28,16.28,16.28,0,0,0-6.1,6.35,18.92,18.92,0,0,0-2.24,9.27,18.92,18.92,0,0,0,2.24,9.27,16.42,16.42,0,0,0,6.1,6.35A16.89,16.89,0,0,0,136.43,57,17.18,17.18,0,0,0,145.21,54.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M196.54,21.59q4.23,4,4.23,11.84V60.36h-3.9V52.79a14.19,14.19,0,0,1-5.94,5.82,19.71,19.71,0,0,1-9.35,2.07q-7.08,0-11.19-3.33a10.77,10.77,0,0,1-4.11-8.79A10.85,10.85,0,0,1,170.06,40q3.78-3.3,12.08-3.3h14.57V33.27q0-5.94-3.21-9t-9.4-3.09A22.56,22.56,0,0,0,176,22.61a20.3,20.3,0,0,0-6.55,3.91l-2-2.93a22.57,22.57,0,0,1,7.64-4.44,28,28,0,0,1,9.36-1.58Q192.31,17.57,196.54,21.59Zm-5.41,33.32a14.88,14.88,0,0,0,5.58-7.08v-8H182.22q-6.25,0-9.07,2.27a7.64,7.64,0,0,0-2.8,6.27A7.84,7.84,0,0,0,173.44,55q3.09,2.4,8.71,2.4A16,16,0,0,0,191.13,54.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M218.51,59.13a20.19,20.19,0,0,1-7.24-3.9L213.14,52a21.6,21.6,0,0,0,6.71,3.66,25.52,25.52,0,0,0,8.58,1.46q6.44,0,9.48-2.12A6.74,6.74,0,0,0,241,49.13a5.49,5.49,0,0,0-1.67-4.23,10.29,10.29,0,0,0-4.11-2.28c-1.62-.49-3.87-1-6.75-1.55a54.89,54.89,0,0,1-8.13-2A12.56,12.56,0,0,1,215,35.7a9.14,9.14,0,0,1-2.2-6.5A10.2,10.2,0,0,1,217,20.86q4.19-3.3,11.92-3.3A29.15,29.15,0,0,1,237,18.7a20.09,20.09,0,0,1,6.51,3L241.61,25a19.46,19.46,0,0,0-5.94-2.85,24.2,24.2,0,0,0-6.83-1c-4,0-7,.74-9,2.2a6.81,6.81,0,0,0-3,5.78,5.74,5.74,0,0,0,1.71,4.43,10.75,10.75,0,0,0,4.19,2.36c1.65.51,4,1.07,6.95,1.66a60,60,0,0,1,8,1.92,12.08,12.08,0,0,1,5.16,3.29A8.85,8.85,0,0,1,245,49a9.92,9.92,0,0,1-4.4,8.46c-2.92,2.12-7,3.18-12.36,3.18A30.65,30.65,0,0,1,218.51,59.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M292.29,40.09H255.76a17.68,17.68,0,0,0,2.53,8.82,16.11,16.11,0,0,0,6.38,6A19.11,19.11,0,0,0,273.74,57a19.49,19.49,0,0,0,7.69-1.5,14.93,14.93,0,0,0,5.9-4.43l2.36,2.68a18.25,18.25,0,0,1-7,5.13,24.21,24.21,0,0,1-20.38-1,20,20,0,0,1-7.76-7.65,21.83,21.83,0,0,1-2.81-11.14A23.17,23.17,0,0,1,254.42,28a19.45,19.45,0,0,1,7.28-7.68,21.06,21.06,0,0,1,20.79,0,19.51,19.51,0,0,1,7.24,7.61A22.86,22.86,0,0,1,292.37,39Zm-28.23-17a15.08,15.08,0,0,0-5.73,5.62,18.15,18.15,0,0,0-2.48,8.17h32.53a16.89,16.89,0,0,0-2.44-8.13,15.75,15.75,0,0,0-13.83-7.65A16.26,16.26,0,0,0,264.06,23.13Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 305.99,
    cy: 53.38,
    r: 5.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRebaseLogo);
export default __webpack_public_path__ + "static/media/rebase-logo.4d0bee8798ae42352608d6945422f46a.svg";
export { ForwardRef as ReactComponent };